// @flow

import elementResizeDetectorMaker from 'element-resize-detector';

export default elementResizeDetectorMaker({
  strategy: 'scroll',
});
